<template>
  <div class="sub-nav">
    <div class="custom-container">
      <ul class="sub-menu">
        <li class="sub-page-item">
          <router-link :to="{name:'Service-web'}"><img src="/static/images/service/navbar_icon_web.svg" alt="">
            <div class="sub-page-text"><span>網頁</span><span class="d-none d-md-block">設計</span></div>
          </router-link>
        </li>
        <li class="sub-page-item">
          <router-link :to="{name:'Service-graphic'}"><img src="/static/images/service/navbar_icon_design.svg" alt="">
            <div class="sub-page-text"><span>平面</span><span class="d-none d-md-block">設計</span></div>
          </router-link>
        </li>
        <li class="sub-page-item">
          <router-link :to="{name:'Service-cis'}"><img src="/static/images/service/navbar_icon_logo.svg" alt="">
            <div class="sub-page-text"><span>CIS</span><span class="d-none d-md-block">/ Logo</span></div>
          </router-link>
        </li>
        <li class="sub-page-item">
          <router-link :to="{name:'Service-seo'}"><img src="/static/images/service/navbar_icon_SEO.svg" alt="">
            <div class="sub-page-text"><span>SEO</span><span class="d-none d-md-block">整體規劃</span></div>
          </router-link>
        </li>
        <li class="sub-page-item">
          <router-link :to="{name:'Service-social'}"><img src="/static/images/service/navbar_icon_social.svg" alt="">
            <div class="sub-page-text"><span class="d-none d-md-block">社群</span>行銷</div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {

    name: 'subNav',
    data() {
      return {}
    }

    ,
  }

</script>
<style lang="scss" scoped>

  .sub-nav {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100px;
    background: black;
    z-index: 1;
    display: flex;
    align-items: center;
    @media screen and(max-width: 992px){
      width: calc(100% - 100px);
      transform: translateX(100px);
    }
    @media screen and(max-width: 768px){
      height: 76px;
      width: calc(100% - 76px);
      transform: translateX(76px);
    }
    @media screen and(max-width: 576px){
      height: 70px;
      width: calc(100% - 70px);
      transform: translateX(70px);
    }
    .custom-container{
      width:100%;
      @media screen and(max-width: 576px){
        padding: 0 5px;
      }
    }
    .sub-menu {
      display: flex;
      justify-content: center;
      @media screen and(max-width: 768px){
        justify-content: space-between;
        padding: 0 6%;
      }
      .sub-page-item {
        align-self: center;
        margin-right: 60px;
        text-align: center;
        @media screen and(max-width: 768px){
          margin-right: 0;
        }
        @media screen and(max-width: 576px) {
          //margin-right: 20px;
        }

        &:last-child {
          margin-right: 0;
        }

        a {
          display: inline-block;
          color: white;

          &:hover {
            color: white;
          }

          img {
            width: 60px;
            height: 60px;
            margin-bottom: 4px;
            @media screen and(max-width: 768px) {
              width: 50px;
              height: 50px;
              margin-bottom: 0;
            }
            @media screen and(max-width: 576px) {
              width: 40px;
              height: 40px;
              margin-bottom: 0;
            }
          }

          .sub-page-text {
            display: flex;
            justify-content: center;
            font-size: 0.75rem;
            letter-spacing: 1.5px;
            font-weight: 500;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/subNav.vue